<template>
  <el-table
    ref="rcBaseTable"
    v-skeleton="skeleton"
    :data="data"
    :border="border"
    :stripe="stripe"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-for="(column, key, index) in columns">
      <el-table-column
        v-if="defTypeList.includes(column.type)"
        :key="key || index"
        v-bind="{ ...$attrs, ...column }"
        v-on="$listeners"
      ></el-table-column>
      <rc-table-item
        v-else
        :key="index || key"
        v-bind="{ ...$attrs, ...column }"
      >
        <template v-for="(_index, name) in $scopedSlots" :slot="name" slot-scope="scope">
          <slot :name="name" v-bind="scope" :index="_index" :column="{ ...column, ...scope.column }"></slot>
        </template>
      </rc-table-item>
    </template>
    <template v-for="tl in emptySlots" :slot="tl">
      <slot :name="tl" :class="tl">
        <empty v-show="emptyCall(tl)" />
      </slot>
    </template>
  </el-table>
</template>

<script>
import RcTableItem from "../RcTableItem";
import Empty from "../RcTableEmpty";

export default {
  name: "RcBaseTable",
  components: {
    RcTableItem,
    Empty
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    empty: {
      type: Boolean,
      default: true
    },
    skeleton: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    stripe: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      emptySlots: ["empty", "append"],
      defTypeList: ["selection", "index", "expand"]
    };
  },
  computed: {
    refs() {
      return {
        table: this.$refs.rcBaseTable
      };
    },
    table() {
      return this.refs.table;
    }
  },
  watch: {
    "skeleton": {
      deep: true,
      handler(val) {
        this.$emit("loading", val);
        this.table.doLayout();
      }
    }
  },
  methods: {
    emptyCall(item) {
      const bool = item === "empty";
      return bool && this.empty;
    }
  }
};
</script>
